import { render, staticRenderFns } from "./TableArea.vue?vue&type=template&id=18dfedf7&scoped=true&"
import script from "./TableArea.vue?vue&type=script&lang=js&"
export * from "./TableArea.vue?vue&type=script&lang=js&"
import style0 from "./TableArea.vue?vue&type=style&index=0&id=18dfedf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dfedf7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18dfedf7')) {
      api.createRecord('18dfedf7', component.options)
    } else {
      api.reload('18dfedf7', component.options)
    }
    module.hot.accept("./TableArea.vue?vue&type=template&id=18dfedf7&scoped=true&", function () {
      api.rerender('18dfedf7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/LeaderBoard/components/TableArea.vue"
export default component.exports